import * as React from 'react';
import { connect } from 'react-redux';
import Footer from 'src/components/layout/Footer/Footer';
import SectionList from 'src/components/Section/SectionList';
import { alertSuccess } from 'src/store/alert/actions';
import './Home.scss';

interface Props {
  alertSuccess: typeof alertSuccess;
}

class HomePageMobile extends React.Component<Props> {
  public render() {
    return (
      <div>
        <div className="home container">
          <div className="row">
            <div className="col-12">
              <SectionList linkBase="/section" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  alertSuccess: (message: string) => dispatch(alertSuccess(message))
});

export default connect(
  null,
  mapDispatchToProps
)(HomePageMobile);



// WEBPACK FOOTER //
// ./src/pages/Home/HomeMobile.tsx